// extracted by css-extract-rspack-plugin
export default {"root":"D3hkn","bodyCellWithImage":"jlIkS","pivotedFirstColumn":"Ov8ag"};